import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import {
    chain as SetInitialValuesChain,
    DispatchSetInitialValues,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SetInitialValues";

addToChainBefore(chain, ExecuteOnSuccessCallback, async props => {
    // Verndale Customization ticket: DSSM-474
    const products = props.apiParameter.cart.cartLines;
    const carrier = props.apiParameter.cart.carrier?.description;
    
    const result = await getProductCategories({
        productIds: [...products!.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productCategories = result.result;
        setGA4Event([...products!], "add_shipping_info", {productCategories, shippingTier: carrier});
    }
    // End of Verndale Customization ticket: DSSM-474
});

addToChainAfter(SetInitialValuesChain, DispatchSetInitialValues, async props => {
    // Verndale Customization ticket: DSSM-474
    const products = props.cart.cartLines;
    const carrier = props.cart.carrier?.description;

    if( typeof products === 'undefined' || products === null || products.length === 0) {
        return;
    }

    const result = await getProductCategories({
        productIds: [...products!.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productCategories = result.result;
        setGA4Event([...products!], "add_shipping_info", {productCategories, shippingTier: carrier});
    }
    // End of Verndale Customization ticket: DSSM-474
});